import {
  EnhancedTableHeader,
  EnhancedTableHeaderType,
} from '@components/table/widgets/shared-with-old';

export const headers: Record<string, EnhancedTableHeader> = {
  InsuredName: {
    name: 'InsuredName',
    title: 'Insured Name',
    type: EnhancedTableHeaderType.Text,
  },
  Relation: {
    name: 'Relation',
    title: 'Relation',
    type: EnhancedTableHeaderType.Text,
  },
  SumInsured: {
    name: 'SumInsured',
    title: 'Sum Insured',
    type: EnhancedTableHeaderType.Text,
  },
  SumInsuredVariance: {
    name: 'SumInsuredVariance',
    title: 'Sum Insured Variance',
    type: EnhancedTableHeaderType.Text,
  },
  NetPremium: {
    name: 'NetPremium',
    title: 'Net Premium',
    type: EnhancedTableHeaderType.Text,
  },
  NetPremiumVariance: {
    name: 'NetPremiumVariance',
    title: 'Net Premium Variance',
    type: EnhancedTableHeaderType.Text,
  },
  PolicyCostVariance: {
    name: 'PolicyCostVariance',
    title: 'Policy Cost Variance',
    type: EnhancedTableHeaderType.Text,
  },
  Charges: {
    name: 'Charges',
    title: 'Charges',
    type: EnhancedTableHeaderType.Text,
  },
  ChargesVariance: {
    name: 'ChargesVariance',
    title: 'Charges Variance',
    type: EnhancedTableHeaderType.Text,
  },
  TPAFees: {
    name: 'TPAFees',
    title: 'TPA Fees',
    type: EnhancedTableHeaderType.Text,
  },
  TPAFeesVariance: {
    name: 'TPAFeesVariance',
    title: 'TPA Fees Variance',
    type: EnhancedTableHeaderType.Text,
  },
  GrossPremium: {
    name: 'GrossPremium',
    title: 'Gross Premium',
    type: EnhancedTableHeaderType.Text,
  },
  GrossPremiumVariance: {
    name: 'GrossPremiumVariance',
    title: 'Gross Premium Variance',
    type: EnhancedTableHeaderType.Text,
  },
  TotalPremium: {
    name: 'TotalPremium',
    title: 'Total Premium',
    type: EnhancedTableHeaderType.Text,
  },
  TotalPremiumVariance: {
    name: 'TotalPremiumVariance',
    title: 'Total Premium Variance',
    type: EnhancedTableHeaderType.Text,
  },
};
